import React from 'react';

import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';

import * as S from './RankSection.styles';

export const RankSection = ({
  title,
  label,
  rank,
}: {
  title: string;
  label: string;
  rank: number;
}) => {
  return (
    <S.SectionRow>
      <S.TitleBase>{title}</S.TitleBase>
      <S.StyledRankWrapper>
        <S.RankContainer>
          <S.RankLabel>{label}</S.RankLabel>
          <S.RankFlexRow>
            <TopRankIcon rank={rank} />
          </S.RankFlexRow>
        </S.RankContainer>
      </S.StyledRankWrapper>
    </S.SectionRow>
  );
};
